import { MonitoringAreas } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/assessment/_components/monitoring-areas";
import { RequirementAreaSelector } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/assessment/_components/requirement-area-selector";
import {
  AreaList,
  Level,
} from "@/services/backend/qpm/buildings/types/building";
import { RequirementDTO } from "@/services/backend/qpm/requirements/types/requirement-dto";
import { AreaType } from "@/services/backend/qpm/buildings/types/building-enum";

const ZERO_UUID = "00000000-0000-0000-0000-000000000000";

function isNoLevel(levelId?: string): boolean {
  return !levelId || levelId === ZERO_UUID;
}

export type RequirementLevelComponentProps = {
  buildingName?: string;
  buildingId: string;
  selectedLevel?: Level;
  availableAreas: AreaList;
  requirement: RequirementDTO;
  areaType: AreaType;
};

export function RequirementLevelComponent({
  buildingName,
  buildingId,
  selectedLevel,
  availableAreas,
  requirement,
  areaType,
}: RequirementLevelComponentProps) {
  const filteredRequirementAreas =
    requirement.areaList?.filter((reqArea) => {
      if (!reqArea.area) {
        return false;
      }
      if (areaType === AreaType.AreaTypeOutside) {
        if (selectedLevel) {
          return (
            reqArea.area.type === AreaType.AreaTypeOutside &&
            reqArea.area.buildingId === buildingId &&
            reqArea.area.levelId === selectedLevel.base.id
          );
        }
        return (
          reqArea.area.type === AreaType.AreaTypeOutside &&
          reqArea.area.buildingId === buildingId &&
          isNoLevel(reqArea.area.levelId)
        );
      }
      if (reqArea.area.type === AreaType.AreaTypeOutside) {
        return false;
      }
      if (reqArea.area.buildingId !== buildingId) {
        return false;
      }
      if (!selectedLevel) {
        return isNoLevel(reqArea.area.levelId);
      }
      return reqArea.area.levelId === selectedLevel.base.id;
    }) || [];

  const selectableAreas = availableAreas.filter((area) => {
    if (
      requirement.areaList?.some((reqArea) => reqArea.areaId === area.base.id)
    ) {
      return false;
    }
    if (areaType === AreaType.AreaTypeOutside) {
      if (area.type !== AreaType.AreaTypeOutside) {
        return false;
      }
      if (selectedLevel) {
        return area.levelId === selectedLevel.base.id;
      }
      return isNoLevel(area.levelId);
    }
    if (area.type === AreaType.AreaTypeOutside) {
      return false;
    }
    if (selectedLevel) {
      return area.levelId === selectedLevel.base.id;
    }
    return isNoLevel(area.levelId);
  });

  return (
    <div>
      <div className="flex flex-col space-y-4">
        {filteredRequirementAreas.length > 0 && (
          <MonitoringAreas
            buildingName={buildingName}
            levelName={selectedLevel?.base.name}
            requirement={requirement}
            selectedAreas={filteredRequirementAreas}
          />
        )}
        <RequirementAreaSelector
          areas={selectableAreas}
          buildingId={buildingId}
          levelId={selectedLevel?.base.id}
          areaType={areaType}
        />
      </div>
    </div>
  );
}
